// Content and resources routes module

import ElearningPackages from '@/router/ElearningPackages.js';
import EvaluationTemplates from '@/router/EvaluationTemplates.js';
import Help from '@/router/Help.js';
import Notes from '@/router/Notes.js';
import Quizzes from '@/router/Quizzes.js';
import RubricBanks from '@/router/RubricBanks.js';
import SlideDecks from '@/router/SlideDecks.js';
import Surveys from '@/router/Surveys.js';
import Videos from '@/router/Videos.js';

export default [
    ...EvaluationTemplates,
    ...Help,
    ...Notes,
    ...Quizzes,
    ...RubricBanks,
    ...SlideDecks,
    ...Surveys,
    ...Videos,
    ...ElearningPackages,
];
